import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";
import authReducer from "./features/auth/authSlice";

// User product context (NEW)
import userReducer from "./features/users/userSlice";

//Calendar
import calendar from "./calendar/reducer";
import baseApi from "./api/baseApi";
// base api

const rootReducer = combineReducers({
  // public
  Layout,
  Login: authReducer,
  auth: authReducer,

  Account,
  ForgetPassword,
  Profile,
  user: userReducer,
  calendar,

  [baseApi.reducerPath]: baseApi.reducer,
});

export default rootReducer;
